



























































































































import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import ReportStepYear from '@/components/report/StepYear.vue';
import ReportStepTickets from '@/components/report/StepTickets.vue';
import ReportStepOptions from '@/components/report/StepOptions.vue';
import { AppModule } from '@/store/modules/app';
import {
  formatApiError,
  stringToNumber,
  getFilenameWithoutSuffixFromUrl,
  downloadFileFromUrl,
  translateViewResource,
} from '@/utils/index';
import { get_report, getReport } from '@/api/report';

@Component({
  name: 'Report',
  components: {
    MaterialCard,
    ReportStepYear,
    ReportStepTickets,
    ReportStepOptions,
  },
})
export default class Report extends Vue {
  public static readonly reportPreviousStepEvent = 'report-previous-step';
  public static readonly reportNextStepEvent = 'report-next-step';

  private readonly steps = [1, 2, 3];
  private readonly stepTitles = new Map<number, string>([
    [1, 'Financial year'],
    [2, 'Tickets'],
    [3, 'Options'],
  ]);
  private step = this.steps[0];
  private readonly updateYearEvent = 'update:year';
  private year = new Date().getFullYear();
  private readonly updateTicketsEvent = 'update:tickets';
  private tickets: string[] = [];
  private groups: string[] = [];
  private readonly updateOptionsEvent = 'update:options';
  private options: Partial<get_report.Request> = {
    viewOptions: Object.values(get_report.ViewOptionEnum).filter(
      o =>
        (o as get_report.ViewOptionEnum) !==
        get_report.ViewOptionEnum.UNKNOWN_OPTION
    ),
    columnFields: Object.values(get_report.ColumnFieldEnum).filter(
      f =>
        (f as get_report.ColumnFieldEnum) !==
          get_report.ColumnFieldEnum.UNKNOWN_FIELD &&
        (f as get_report.ColumnFieldEnum) !==
          get_report.ColumnFieldEnum.AGGREGATED_TOTAL
    ),
  };
  private allowDownload = true;

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get vertical() {
    return this.isMobile;
  }

  get reportPreviousStepEvent() {
    return Report.reportPreviousStepEvent;
  }

  get reportNextStepEvent() {
    return Report.reportNextStepEvent;
  }

  get canDownload() {
    return this.step >= this.steps[this.steps.length - 1] && this.allowDownload;
  }

  private stepToTitle(step: number) {
    const msg = this.stepTitles.get(step);
    if (msg) {
      return `${this.$t('Select {msg}', {
        msg: (this.$t(msg) as string).toLowerCase(),
      })}`;
    }
    return '';
  }

  private handlePreviousStep() {
    if (this.step != this.steps[0]) {
      this.step -= 1;
    }
  }

  private handleNextStep() {
    if (this.step != this.steps[this.steps.length - 1]) {
      this.step += 1;
    }
  }

  private async download() {
    try {
      const req = {
        year: stringToNumber(this.year),
        productGroups: this.groups,
        // productIds: this.tickets,
      } as get_report.Request;
      if (
        this.options.aggregatedMonthRange &&
        (this.options.aggregatedMonthRange.start ||
          this.options.aggregatedMonthRange.end)
      ) {
        req.aggregatedMonthRange = {};
        if (this.options.aggregatedMonthRange.start) {
          req.aggregatedMonthRange.start = this.options.aggregatedMonthRange.start;
        }
        if (this.options.aggregatedMonthRange.end) {
          req.aggregatedMonthRange.end = this.options.aggregatedMonthRange.end;
        }
      }
      if (this.options.viewOptions && this.options.viewOptions.length > 0) {
        req.viewOptions = this.options.viewOptions.filter(
          o =>
            o &&
            (o as get_report.ViewOptionEnum) !==
              get_report.ViewOptionEnum.UNKNOWN_OPTION
        );
      }
      if (this.options.columnFields && this.options.columnFields.length > 0) {
        req.columnFields = this.options.columnFields.filter(
          o =>
            o &&
            (o as get_report.ColumnFieldEnum) !==
              get_report.ColumnFieldEnum.UNKNOWN_FIELD
        );
      }
      this.allowDownload = false;
      const res = await getReport(req);

      const filename = `${getFilenameWithoutSuffixFromUrl(res.url)}.xlsx`;
      await downloadFileFromUrl(res.url, filename, '*/*');
      this.$toast.success(
        this.$t('Downloaded {msg}', {
          msg: 'EXCEL',
        }) as string,
        {
          icon: 'mdi-file-download',
        }
      );

      AppModule.StopProgress();
      this.allowDownload = true;
    } catch (err) {
      AppModule.StopProgress();
      this.allowDownload = true;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t(`Download`) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private translateViewResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateViewResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }
}
